import { createAction } from '@reduxjs/toolkit';

export const SETUP_ACCOUNT = 'Signup/AccountSetup/SETUP_ACCOUNT';
export const SETUP_ACCOUNT_SUCCESS = 'Signup/AccountSetup/SETUP_ACCOUNT_SUCCESS';
export const SETUP_ACCOUNT_FAILURE = 'Signup/AccountSetup/SETUP_ACCOUNT_FAILURE';

export const setupAccount = createAction(SETUP_ACCOUNT);
export const setupAccountSuccess = createAction(SETUP_ACCOUNT_SUCCESS);
export const setupAccountFailure = createAction(SETUP_ACCOUNT_FAILURE);
